module.exports = __webpack_public_path__ + "static/media/newlogo.c83e9341.png";